/**
 * Created by olga on 22.09.2026
 */

const PinConfirmationWindow = Prefab.createWindow(
    "pin_confirmation_window",
    "pin_confirmation_window_prefab_json"
);
